import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, PropType, ref, watch } from 'vue';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { EventBus } from '@/helpers/EventBusHelper';
import { checklistFieldsPlaceholders } from '@/regex/checklistFieldsAdditionalConfiguration';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistStringFieldModule',
  props: {
    pId: { type: String, required: true },
    activeProductFormId: { type: Number, default: null },
    isDisabled: { type: Boolean, default: false },
    debounceToggleIsActive: {
        type: Function as PropType<(state: boolean) => void>,
        default: null,
    },
    temporaryDisabledPIDs: { type: Array as PropType<string[]>, default: () => [] },
},
  emits: ['updateStoreFieldValue'],
  setup(__props, { emit }) {

const props = __props;




const { proxy } = getCurrentInstance()!;

const value = ref('');
const placeholders = checklistFieldsPlaceholders;

const readOnlyField = computed(() => props.temporaryDisabledPIDs.includes(props.pId));

const fieldValue = computed(() => {
    if (props.activeProductFormId == null) {
        return '';
    }

    return store.getters['configurator/activeProductFormValue'](props.pId, props.activeProductFormId) as string | null;
});

const textPlaceHolder = computed(() => {
    const placeholderObj = placeholders.find((item) => item.pID === props.pId);
    return placeholderObj ? proxy!.$t(placeholderObj.placeholder) : '';
});

function onChange(newValue: string) {
    EventBus.$emit(EventBusEvents.changesInDataMade, { state: true });

    emit(EventBusEvents.updateStoreFieldValue, {
        pId: props.pId,
        value: String(newValue),
        productFormId: props.activeProductFormId,
    });
}

function onBlur() {
    props.debounceToggleIsActive && props.debounceToggleIsActive(false);
}

function onFocus() {
    window.setTimeout(() => {
        props.debounceToggleIsActive && props.debounceToggleIsActive(true);
    }, 200);
}

watch(
    fieldValue,
    (newValue: string | null) => {
        if (newValue == null) {
            value.value = '';
            return;
        }

        value.value = newValue;
    },
    { immediate: true, deep: true },
);

return { __sfc: true,props, emit, proxy, value, placeholders, readOnlyField, fieldValue, textPlaceHolder, onChange, onBlur, onFocus }
}

})